/**
 * Dónde aplica la membresía gratuita por Clerk.
 *
 * El alta free (cuenta Clerk → portal) nació como el embudo del tráfico de
 * AFUERA: Estados Unidos, Colombia, Ecuador, Paraguay y el resto de
 * Latinoamérica entran al sitio argentino y se los invita a ser miembros.
 *
 * Argentina quedaba afuera por una sola razón: tenía producto propio cobrado
 * por Mercado Pago. Apagado ese canal, la excepción se cae sola — hoy todos
 * pagan por Stripe, así que todos entran por el mismo embudo. Si Mercado Pago
 * vuelve a vender, Argentina vuelve a salir del alta free.
 *
 * El país lo resuelve el Worker y lo inyecta antes del primer paint
 * (`resolveCheckoutCountryCode` lo lee de ahí). No se detecta por IP en el
 * cliente ni se adivina por timezone cuando el edge ya respondió.
 *
 * El corte de verdad vive en el servidor, en `api/free-join.ts`: esto es la
 * capa de UI, para no ofrecer un camino que el backend va a rechazar.
 */

import { isMercadoPagoSalesEnabled } from "@/lib/mercadoPagoSales";
import { resolveCheckoutCountryCode } from "@/lib/resolveCheckoutCountryCode";

/** Países con producto propio, fuera del embudo free (solo si ese canal vende). */
export const COUNTRIES_WITHOUT_FREE_MEMBERSHIP: ReadonlySet<string> = new Set(["AR"]);

/** Página de membresía de Argentina, cobrada por Mercado Pago. */
export const AR_MEMBERSHIP_PATH = "/ar/invitacion";

/**
 * A dónde mandar a un argentino que intentó entrar por el alta free.
 *
 * Con la venta por Mercado Pago apagada esa página no puede cobrar, así que
 * mandarlo ahí es dejarlo frente a un botón que falla. Mientras el canal esté
 * apagado vuelve al inicio.
 */
export function resolveNonFreeCountryDestination(): string {
  return isMercadoPagoSalesEnabled() ? AR_MEMBERSHIP_PATH : "/";
}

/**
 * @param country ISO2 ya resuelto. Si no se pasa, se resuelve con el país del
 *                Worker. Un país desconocido NO bloquea: falla abierto.
 */
export function isFreeMembershipCountry(country?: string | null): boolean {
  // Sin Mercado Pago vendiendo no hay país con producto propio: entran todos.
  if (!isMercadoPagoSalesEnabled()) return true;
  const iso = (country ?? resolveCheckoutCountryCode(null) ?? "").toUpperCase();
  if (!iso || iso === "UNKNOWN") return true;
  return !COUNTRIES_WITHOUT_FREE_MEMBERSHIP.has(iso);
}
